export default "__VITE_ASSET__B2jXrQnW__"